export default {
  header: 'Nuevos pedidos pausados',
  text: 'Toca en cualquier lugar para restaurar',
};
